import * as React from 'react';
import {TimelineSeparator, TimelineConnector, Timeline as MUITimeline} from '@mui/lab';
import {Typography} from '@mui/material';
import type {PortalTimelineProps} from './types';
import {StyledTimelineContent, StyledTimelineDot, StyledTimelineItem} from './styles';

export function Timeline({content, customPaddingBottom}: PortalTimelineProps) {
	const contentLength = content.length;
	return (
		<MUITimeline>
			{content.map((data, index) => (
				<StyledTimelineItem key={index}>
					<TimelineSeparator sx={{gap: 1}}>
						<StyledTimelineDot />
						{contentLength !== index + 1 && <TimelineConnector sx={{width: '1px'}} />}
					</TimelineSeparator>
					<StyledTimelineContent customPaddingBottom={customPaddingBottom}>
						<Typography sx={{lineHeight: 'normal'}}>{data.title}</Typography>
						<Typography variant="body2" color="text.secondary">
							{data.description}
						</Typography>
					</StyledTimelineContent>
				</StyledTimelineItem>
			))}
		</MUITimeline>
	);
}
